import OpenInNew from "@mui/icons-material/OpenInNew";
import { SidebarLink } from "@tngtech/tng-ui";
import React from "react";

export const OtherAppSidebarLink = ({
  title,
  href,
  icon,
  newTabHint,
}: {
  title: string;
  href: string;
  icon: React.ComponentType;
  newTabHint: string;
}) => (
  <SidebarLink
    title={
      <>
        {title}
        <OpenInNew
          titleAccess={newTabHint}
          fontSize="inherit"
          sx={{ marginLeft: 0.5, verticalAlign: "-0.125em" }}
        />
      </>
    }
    href={href}
    target="_blank"
    rel="noopener"
    icon={icon}
  />
);
